import { getCurrentPath } from "@faire/web/common/Path";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";

import { HeaderButton } from "@faire/retailer/components/Header/styled";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

import { useNavigateAndHideMenu } from "./Navigation/useNavigateAndHideMenu";

const HeaderMobileSignUpBase: React.FC = () => {
  const isSSR = useIsSSR();
  const { retailer } = useRetailerStore(["retailer"]);
  const { navigateToSignUp } = useNavigateAndHideMenu();

  if (retailer === undefined) {
    return (
      <HeaderButton
        onClick={() =>
          navigateToSignUp(undefined, {
            sourceId: "mobile_side_catnav_signup_cta",
          })
        }
        // We set a link for graceful degredation in SSR.
        linkTo={
          isSSR
            ? getCurrentPath()
                .replace({
                  signUp: "1",
                })
                .toString()
            : undefined
        }
        data-test-id="signUpButton"
      >
        <StrictLocalMsg defaultMessage="Sign up to shop" />
      </HeaderButton>
    );
  }

  return null;
};

export const HeaderMobileSignUp = observer(HeaderMobileSignUpBase);
